import React from 'react';
import {observer} from "mobx-react";
import {BaseComposer} from "./base-composer";

export const ModuleComposer = (settings) => (Module) => BaseComposer(settings)(observer((props) => {
  if(props.controller.state.hasError) {
    throw props.controller.state.error;
  }

  return props.controller.state?.isPopulated ? <Module {...props} /> : null;
}));


